import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { breakpoints } from '@/css/resources/variables.css';
import { grid, resetFirstLastMargins } from '@/css/resources/placeholders.css';
import {
	fontStyle,
	fluidPadding,
	fluidBorderWidth,
} from '@/css/resources/mixins.css';

const getDynamicStyles = (styles) =>
	cssObj(fluidBorderWidth(styles?.border?.width), {
		background: styles?.backgroundColor,
		borderColor: styles?.border?.color,

		'.supt-pageHeaderFull__inner': cssObj(fluidPadding(styles?.padding), {
			'.supt-pageHeaderFull__title': fontStyle({
				...styles?.title?.typography,
				textAlign: styles?.title?.textAlignment,
				color: styles?.title?.color,
			}),
		}),
	});

const getStyles = (styles) =>
	css(getDynamicStyles(styles), {
		position: 'relative',
		borderStyle: 'solid',

		'.supt-pageHeaderFull__inner': cssObj(grid, {
			position: 'relative',
			zIndex: 1,

			'& > *': {
				gridColumn: '1/13',

				[`@media (min-width: ${breakpoints.tablet})`]: {
					gridColumnEnd: '12',
				},

				[`@media (min-width: ${breakpoints.medium})`]: {
					gridColumnEnd: '11',
				},

				[`@media (min-width: ${breakpoints.laptop})`]: {
					gridColumnEnd: '10',
				},
			},

			'.supt-pageHeaderFull__title': resetFirstLastMargins,
		}),

		'.supt-pageHeaderFull__backgroundImage': {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			zIndex: 0,

			'*': {
				height: '100%',
				paddingBottom: '0 !important',
			},

			img: {
				display: 'block',
				width: '100%',
				height: '100%',
				objectFit: 'cover',
				objectPosition: 'right center' /* TODO: make configurable */,
				pointerEvents: 'none',
			},
		},
	});

const getEditStyles = () =>
	css({
		maxWidth: 'none !important',

		'.supt-pageHeaderFull__backgroundImage': {
			margin: 0,
		},
	});

export { getStyles, getEditStyles };
